import { useContext, useEffect, useState } from 'react';
import { shortenAddress } from '../../../../helpers/address';
import { DaoStatusBadge, DaoUserIcon } from '../daoComponents/daoList';
import { DaoContext, useSnapshotFunctions } from '../daoHook.js';
import { DaoRedirectBadge } from '../daoComponents/redirectionBadge';
import { toast } from 'react-hot-toast';
import { mdParser } from '../../../markdown/mdRender.jsx';

const CurrentResults = () => {
  const { daoData } = useContext(DaoContext);
  const { selectedProposal } = daoData;
  const { choices, scores, scores_total, state, author, snapshot, start, end } =
    selectedProposal || {};

  const isOver = state !== 'active';

  return (
    <div className='pl-12 md:px-12'>
      <div className='w-full rounded-[12px] border border-[#E7E8EC] bg-white px-[16px] py-[12px] dark:border-none dark:bg-jacarta-700'>
        <DaoStatusBadge status={state} />
        <div className='relative my-5 ml-0'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='12'
            height='72'
            viewBox='0 0 12 72'
            fill='none'
          >
            <circle
              cx='6'
              cy='6'
              r='5.5'
              transform='rotate(90 6 6)'
              fill='#7445FF'
              fillOpacity='0.6'
              stroke='#7445FF'
            />
            <circle cx='6' cy='66' r='5.5' stroke='#7445FF' />
            <path d='M6 12L6 60' stroke='#7445FF' strokeDasharray='3 3' />
          </svg>
          <div className='absolute left-5 top-[-5px] font-normal text-[#7D7F94] dark:text-white'>
            Start date {new Date(start * 1000).toString()?.substr(3, 18)}
          </div>
          <div className='absolute bottom-[-5px] left-5 font-normal text-[#7D7F94] dark:text-white'>
            End date {new Date(end * 1000).toString()?.substr(3, 18)}
          </div>
        </div>
        <div className='mt-5 space-y-2 lg:flex lg:space-x-2 lg:space-y-0'>
          {/*<DaoRedirectBadge name={'Identifier'} text={id} isLabelAddress />*/}
          <DaoRedirectBadge
            name={'Creator'}
            text={author}
            isLabelAddress
            isToScan
            redirectUrl={`https://bscscan.com/address/${author}`}
          />
          <DaoRedirectBadge
            name={'Snapshot'}
            text={snapshot}
            isToScan
            redirectUrl={`https://bscscan.com/block/${snapshot}`}
          />
        </div>
      </div>

      <div className='mt-6 w-full rounded-[12px] border border-[#E7E8EC] px-[16px] py-[12px] dark:border-none dark:bg-jacarta-700'>
        <div className='font-semibold '>{!isOver && 'Current'} Results</div>
        {scores?.some((score) => score) ? (
          choices?.map((item, index) => {
            const percentage = (scores[index] / scores_total) * 100;
            return (
              <div key={`currentResult${index}`} className='my-5'>
                <div className='flex w-full'>
                  <span className='text-[16px] text-[#7445FF]'>
                    {parseFloat(percentage).toFixed(2)}%
                  </span>
                  <span className='ml-auto font-normal '>{scores[index]} Votes</span>
                </div>
                <div className='relative h-[8px] w-full rounded-full bg-[#D9D9D9] p-[1px] dark:bg-jacarta-900'>
                  <div
                    className='h-full rounded-full bg-[#7445FF] dark:bg-accent-light'
                    style={{ width: `${percentage}%` }}
                  />
                </div>
                <span className='text-[14px] text-[#666] dark:text-white'>{item}</span>
              </div>
            );
          })
        ) : (
          <div className='my-10 text-[14px] text-[#666]'>No votes yet. Vote now!</div>
        )}
      </div>
    </div>
  );
};

const PreviousVotes = () => {
  const [votes, setVotes] = useState([]);
  const { daoData } = useContext(DaoContext);
  const { selectedProposal } = daoData;
  const { getAllVotes } = useSnapshotFunctions();
  useEffect(() => {
    getAllVotes().then((res) => {
      setVotes(res.votes);
    });
  }, []);

  useEffect(() => {
    getAllVotes().then((res) => {
      setVotes(res.votes);
    });
  }, [selectedProposal]);

  return (
    <div className='mt-5 w-full'>
      <table className='w-full'>
        <thead>
          <tr className=''>
            <th className='rounded-tl-[12px] bg-[#E7E8EC] px-[16px] py-[12px] text-left text-[14px] font-normal text-[#000] dark:bg-jacarta-600 dark:text-white'>
              Votes({votes.length})
            </th>
            <th className='bg-[#E7E8EC] px-[16px] py-[12px] text-[14px] font-normal text-[#000] dark:bg-jacarta-600' />
            <th className='rounded-tr-[12px] bg-[#E7E8EC] px-[16px] py-[12px] text-right text-[14px] font-normal text-[#000] dark:bg-jacarta-600' />
          </tr>
        </thead>
      </table>
      <div className='max-h-[50vh] overflow-auto'>
        <table className='w-full'>
          <tbody>
            {votes.map((item, index) => (
              <tr
                key={'vote' + index}
                className='border-b border-b-[#E7E8EC] dark:border-b-jacarta-800 dark:bg-jacarta-700'
              >
                <td className='px-[16px] py-[12px] text-[14px] font-normal text-[#000] dark:bg-jacarta-700 dark:text-white'>
                  <div className='items-center'>
                    <div
                      className='flex w-fit cursor-pointer items-center underline'
                      onClick={() => {
                        //bscscan
                        window.open(`https://bscscan.com/address/${item.voter}`, '_blank');
                      }}
                    >
                      <span className='ml-[8px]'>{shortenAddress(item.voter)}</span>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='13'
                        height='12'
                        viewBox='0 0 13 12'
                        fill='none'
                        className='ml-1 mt-1'
                      >
                        <g clipPath='url(#clip0_15_224)'>
                          <path
                            d='M2.49447 5.71311C2.49449 5.64611 2.50773 5.57977 2.53346 5.5179C2.55918 5.45603 2.59687 5.39985 2.64436 5.35259C2.69185 5.30533 2.74821 5.26791 2.8102 5.24249C2.87219 5.21707 2.9386 5.20415 3.0056 5.20446L3.85298 5.20723C3.9881 5.20723 4.11767 5.2609 4.21321 5.35644C4.30875 5.45198 4.36242 5.58156 4.36242 5.71667V8.92107C4.45786 8.89279 4.58001 8.86262 4.71441 8.83097C4.80753 8.80906 4.89052 8.75634 4.94992 8.68136C5.00932 8.60638 5.04166 8.51353 5.04168 8.41786V4.44331C5.04168 4.30819 5.09535 4.1786 5.19089 4.08305C5.28642 3.98749 5.416 3.9338 5.55112 3.93377H6.40108C6.5362 3.9338 6.66578 3.98749 6.76131 4.08305C6.85685 4.1786 6.91052 4.30819 6.91052 4.44331V8.13234C6.91052 8.13234 7.12316 8.04629 7.33016 7.95886C7.40708 7.92633 7.47272 7.87187 7.51889 7.80227C7.56505 7.73267 7.58971 7.65103 7.58977 7.56751V3.16966C7.58977 3.03457 7.64343 2.905 7.73895 2.80947C7.83447 2.71393 7.96402 2.66025 8.09912 2.66022H8.94818C9.08321 2.66035 9.21266 2.71408 9.30809 2.80961C9.40352 2.90513 9.45713 3.03464 9.45713 3.16966V6.79113C10.1933 6.25766 10.9393 5.61599 11.5313 4.84446C11.6172 4.73246 11.674 4.60095 11.6967 4.46165C11.7194 4.32236 11.7073 4.1796 11.6614 4.04613C11.3874 3.2577 10.9518 2.53516 10.3825 1.92475C9.81315 1.31433 9.12267 0.829491 8.35523 0.501242C7.58778 0.172994 6.76025 0.00856917 5.92561 0.01849C5.09097 0.0284109 4.2676 0.212459 3.50817 0.558856C2.74874 0.905253 2.06998 1.40637 1.51534 2.03014C0.960693 2.65392 0.542371 3.3866 0.287141 4.18133C0.0319108 4.97605 -0.0546059 5.8153 0.0331265 6.64537C0.120859 7.47545 0.380908 8.27807 0.796634 9.00188C0.869063 9.12674 0.975623 9.22834 1.10379 9.29473C1.23196 9.36113 1.37642 9.38957 1.5202 9.37671C1.68081 9.36257 1.88079 9.34259 2.11855 9.3147C2.22203 9.30293 2.31756 9.25351 2.38696 9.17585C2.45635 9.09819 2.49476 8.99772 2.49487 8.89358V5.71311'
                            fill='#131740'
                            className='fill-[#131740] dark:fill-white'
                          />
                          <path
                            d='M2.47638 10.8521C3.37136 11.5032 4.42901 11.894 5.53231 11.9813C6.63562 12.0686 7.74156 11.849 8.72779 11.3468C9.71402 10.8445 10.5421 10.0792 11.1204 9.13558C11.6987 8.19192 12.0046 7.10669 12.0044 5.99993C12.0044 5.86147 11.998 5.72518 11.9888 5.58929C9.79686 8.85848 5.74962 10.3868 2.47638 10.8521Z'
                            fill='#131740'
                            className='fill-[#131740] dark:fill-white'
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_15_224'>
                            <rect width='12.0044' height='12' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </td>
                <td className='w-1/2 min-w-[50%] px-[16px] py-[12px] text-left text-[14px] font-normal text-[#000]  dark:bg-jacarta-700 dark:text-white'>
                  <span className='text-left'>{selectedProposal.choices[item.choice - 1]}</span>
                </td>
                <td className='flex min-w-[30%] px-[16px] py-[12px] text-right text-[14px] font-normal text-[#000]  dark:bg-jacarta-700 dark:text-white'>
                  <span className='ml-auto'>{item.vp}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <table className='w-full'>
        <tr className='w-full'>
          <th className='rounded-bl-[12px] bg-[#E7E8EC] px-[16px] py-[12px] text-left text-[14px] font-normal text-[#000] text-[#E7E8EC] dark:bg-jacarta-600'>
            <span className='text-transparent'>{'tes'}</span>
          </th>
          <th className='bg-[#E7E8EC] px-[16px] py-[12px] text-[14px] font-normal text-[#000] dark:bg-jacarta-600' />
          <th className='rounded-br-[12px] bg-[#E7E8EC] px-[16px] py-[12px] text-right text-[14px] font-normal text-[#000] dark:bg-jacarta-600' />
        </tr>
      </table>
    </div>
  );
};

const VoteButton = ({ voteSelected }) => {
  const { daoData } = useContext(DaoContext);
  const { vote } = useSnapshotFunctions();
  const [buttonText, setButtonText] = useState('Cast Your Vote');
  const { selectedProposal, votingPower } = daoData;
  const { choices, currentVote, state } = selectedProposal || {};
  const disabled =
    (!voteSelected && voteSelected !== 0) ||
    voteSelected === currentVote - 1 ||
    choices?.length === 0 ||
    !(votingPower > 0) ||
    state !== 'active';

  return (
    <>
      <button
        onClick={async () => {
          if (disabled) return;
          setButtonText('Voting...');
          try {
            await vote(voteSelected + 1);
          } catch (e) {
            toast.error("Vote couldn't be casted.");
            setButtonText('Cast Your Vote');
            return;
          }
          toast.success('Voted successfully');
          setButtonText('Cast Your Vote');
        }}
        className={
          disabled
            ? 'mt-7 cursor-default rounded-[12px] bg-[#E7E8EC] px-[16px] py-[12px] text-[14px] text-[#7D7F94] dark:bg-jacarta-600 dark:text-white'
            : 'mt-7 rounded-[12px] bg-[#7445FF] px-[16px] py-[12px] text-[14px] text-[#FFF]'
        }
      >
        {buttonText}
      </button>
      {votingPower ? (
        <div className='alert-success mt-2 flex rounded-[12px] px-[16px] py-[8px]'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='32'
            height='32'
            viewBox='0 0 32 32'
            fill='none'
          >
            <circle cx='16' cy='16' r='16' fill='#7445FF' />
            <path
              d='M17.4239 8L17.0652 18.9891H14.4565L14.087 8H17.4239ZM14 22.3913C14 21.9275 14.1594 21.5435 14.4783 21.2391C14.8043 20.9275 15.2319 20.7717 15.7609 20.7717C16.2971 20.7717 16.7246 20.9275 17.0435 21.2391C17.3623 21.5435 17.5217 21.9275 17.5217 22.3913C17.5217 22.8406 17.3623 23.221 17.0435 23.5326C16.7246 23.8442 16.2971 24 15.7609 24C15.2319 24 14.8043 23.8442 14.4783 23.5326C14.1594 23.221 14 22.8406 14 22.3913Z'
              fill='white'
            />
          </svg>{' '}
          <span className='ml-2 mt-1'> You have {votingPower} voting power.</span>
        </div>
      ) : (
        <div className='alert-error mt-2 flex rounded-[12px] px-[16px] py-[8px]'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='32'
            height='32'
            viewBox='0 0 32 32'
            fill='none'
          >
            <circle cx='16' cy='16' r='16' fill='#7445FF' />
            <path
              d='M17.4239 8L17.0652 18.9891H14.4565L14.087 8H17.4239ZM14 22.3913C14 21.9275 14.1594 21.5435 14.4783 21.2391C14.8043 20.9275 15.2319 20.7717 15.7609 20.7717C16.2971 20.7717 16.7246 20.9275 17.0435 21.2391C17.3623 21.5435 17.5217 21.9275 17.5217 22.3913C17.5217 22.8406 17.3623 23.221 17.0435 23.5326C16.7246 23.8442 16.2971 24 15.7609 24C15.2319 24 14.8043 23.8442 14.4783 23.5326C14.1594 23.221 14 22.8406 14 22.3913Z'
              fill='white'
            />
          </svg>{' '}
          <span className='ml-2 mt-1'>You need at least 1 Nfts of voting power to vote.</span>
        </div>
      )}
      {state !== 'active' && (
        <div className='alert-error mt-2 flex rounded-[12px] px-[16px] py-[8px]'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='32'
            height='32'
            viewBox='0 0 32 32'
            fill='none'
          >
            <circle cx='16' cy='16' r='16' fill='#7445FF' />
            <path
              d='M17.4239 8L17.0652 18.9891H14.4565L14.087 8H17.4239ZM14 22.3913C14 21.9275 14.1594 21.5435 14.4783 21.2391C14.8043 20.9275 15.2319 20.7717 15.7609 20.7717C16.2971 20.7717 16.7246 20.9275 17.0435 21.2391C17.3623 21.5435 17.5217 21.9275 17.5217 22.3913C17.5217 22.8406 17.3623 23.221 17.0435 23.5326C16.7246 23.8442 16.2971 24 15.7609 24C15.2319 24 14.8043 23.8442 14.4783 23.5326C14.1594 23.221 14 22.8406 14 22.3913Z'
              fill='white'
            />
          </svg>{' '}
          <span className='ml-2 mt-1'>
            {state === 'closed'
              ? 'This Proposal is Over!'
              : 'This Proposal has not started to vote yet!'}
          </span>
        </div>
      )}
    </>
  );
};

const Options = () => {
  const { daoData } = useContext(DaoContext);
  const [selected, setSelected] = useState(0);
  const { selectedProposal } = daoData;
  const { choices, currentVote } = selectedProposal || {};
  useEffect(() => {
    if (currentVote) setSelected(currentVote - 1);
    else setSelected(null);
  }, [currentVote, selectedProposal]);
  return (
    <>
      <div className='mt-5 w-full space-y-2'>
        {choices?.map((item, index) => (
          <div
            key={item * index}
            onClick={() => setSelected(index)}
            className='flex cursor-pointer items-center rounded-[12px] border border-[#E7E8EC] bg-white px-[24px] py-[12px] text-[16px] dark:border-jacarta-400 dark:bg-jacarta-700'
          >
            <span className='mr-[20px] dark:text-white'>{item}</span>
            <div className='ml-auto h-[24px] w-[24px] rounded-full border border-[#7445FF] p-[1px]'>
              {selected === index && <div className='h-full w-full rounded-full bg-[#7445FF]' />}
            </div>
          </div>
        ))}
      </div>
      <VoteButton voteSelected={selected} />
    </>
  );
};

const daoUpdater = {
  '0x5ba7b3a0f465edacd918f96a8230c2b19cbae5b309ec304cc17a0ea6c828cf06': [
    ['Initial Supply', 'Total Supply'],
    ['Initial Supply', 'Total Supply'],
    ['The initial supply of Squad', 'The total supply of Squad'],
  ],
};

const getEditedBody = (body, proposalId) => {
  const proposal = daoUpdater[proposalId];
  if (!proposal) return body;
  proposal.forEach((item) => {
    body = body.replace(item[0], item[1]);
  });
  return body;
};

export const DaoVoteWithDetails = () => {
  const { daoData } = useContext(DaoContext);
  const { selectedProposal } = daoData;
  const { body, title } = selectedProposal || {};

  const bodyParsed = mdParser.render(getEditedBody(body, selectedProposal?.id));
  return (
    <>
      <div className='mt-5 grid grid-cols-1 md:grid-cols-2'>
        <div className='mb-5 md:mb-0'>
          <div className='ml-1 flex'>
            <div>
              <DaoUserIcon />
            </div>
            <div className='w-full md:pl-3'>
              <div className='pl-3 md:pl-0'>
                <span className='text-[16px] font-semibold text-[#000] dark:text-white'>
                  {title}
                </span>
                <div
                  className='custom-html-style mb-10 mt-4 text-[14px] text-[#000] dark:text-white'
                  dangerouslySetInnerHTML={{ __html: bodyParsed }}
                />
              </div>

              <span className='text-[16px] font-semibold text-[#000] dark:text-white'>
                Choose Your Side
              </span>
              <Options />
              <PreviousVotes />
            </div>
          </div>
        </div>
        <CurrentResults />
      </div>
    </>
  );
};
